module.exports = __webpack_public_path__ + "static/media/eggetarian.758c2e76.svg";